import OBTDataGrid from './OBTDataGrid';
export default OBTDataGrid;
export { default as OBTDataGridInterface } from './OBTDataGridInterface';
